/**
 * Aufgeben mit Rueckfrage (Masterprompt Abschnitt 90).
 *
 * Aufgeben ist endgueltig und kostet das Match - deshalb nie auf einen Druck
 * allein. Der Knopf liegt bewusst abseits der Knoepfe, die man staendig
 * benutzt, und die Rueckfrage sagt in klaren Worten, was passiert
 * (Produktentscheidung vom 25.09.2026).
 *
 * "Weiterspielen" steht links und ist hervorgehoben: Wer aus Versehen
 * hierher geraten ist, kommt mit dem naechstliegenden Knopf wieder heraus.
 */

import { useState } from 'react';
import { createPortal } from 'react-dom';
import { t } from '../i18n/index.js';
import { FahneSymbol } from './symbole.js';

export function SurrenderButton({ onSurrender }: { onSurrender: () => void }) {
  const [fragt, setFragt] = useState(false);

  return (
    <>
      {/* Eine weisse Fahne statt des Wortes (13.10.2026) - das Wort bleibt als Tooltip. */}
      <button
        type="button"
        className="dl-surrender"
        title={t.surrender.button}
        aria-label={t.surrender.button}
        onClick={() => setFragt(true)}
      >
        <FahneSymbol />
      </button>

      {/*
        Die Rueckfrage haengt direkt am Dokument, nicht im HUD.
        Im Spiel aufgefallen (25.09.2026): Sie lag hinter dem geoeffneten Army
        Composer. Das HUD bildet eine eigene Ebene - was darin liegt, kann nie
        ueber etwas kommen, das ausserhalb liegt, egal wie hoch die Zahl ist.
      */}
      {fragt &&
        createPortal(
          <div className="dl-confirm">
            <div className="dl-confirm__box">
              <h2 className="dl-confirm__title">{t.surrender.title}</h2>
              <p className="dl-confirm__body">{t.surrender.body}</p>
              <p className="dl-confirm__hint">{t.surrender.hint}</p>

              <div className="dl-confirm__buttons">
                <button
                  type="button"
                  className="dl-button dl-button--primary"
                  onClick={() => setFragt(false)}
                >
                  {t.surrender.cancel}
                </button>
                <button
                  type="button"
                  className="dl-button dl-button--danger"
                  onClick={() => {
                    setFragt(false);
                    onSurrender();
                  }}
                >
                  {t.surrender.confirm}
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}
